// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mw-container[data-v-76436eb3]{max-width:1440px;margin:0 auto}.mw-container[data-type=wide][data-v-76436eb3]{max-width:1880px}", ""]);
// Exports
module.exports = exports;
